import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ScopeComponent } from './components/scope/scope.component'
import { ShellComponent } from './components/shell/shell.component'
import { AuthGuard } from './guards/auth.guard'
import { domainNameTransitionGuard } from './guards/domain-name-transition.guard'
import { ReadingsGuard } from './guards/readings.guard'
import { ReportsGuard } from './guards/reports.guard'
import { ScopesGuard } from './guards/scope.guard'
import { WatchesGuard } from './guards/watches.guard'
import { WasteGuard } from './guards/waste.guard'
import { environment } from '../../environments/environment'

const routes: Routes = [
  { path: '', redirectTo: '/map', pathMatch: 'full' },
  {
    path       : '',
    component  : ShellComponent,
    canActivate: [ AuthGuard ],
    canMatch   : [ domainNameTransitionGuard ],
    children   : [
      {
        path        : 'map',
        loadChildren: () => import('../modules/map/map.module').then(m => m.MapModule)
      },
      {
        path       : ':scopeId',
        component  : ScopeComponent,
        canActivate: [ ScopesGuard ],
        children   : [
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
          {
            path        : 'dashboard',
            loadChildren: () => import('../modules/dashboard/dashboard.module').then(m => m.DashboardModule)
          },
          {
            path        : 'charts',
            loadChildren: () => import('../modules/charts/charts.module').then(m => m.ChartsModule)
          },
          {
            path        : 'reporting-processes',
            loadChildren: () => import('../modules/reports/reports.module').then(m => m.ReportsModule),
            canMatch    : [ ReportsGuard ],
          },
          {
            path        : 'reading-forms',
            loadChildren: () => import('../modules/readings/readings.module').then(m => m.ReadingsModule),
            canMatch    : [ ReadingsGuard ]
          },
          {
            path        : 'watch-procedures',
            loadChildren: () => import('../modules/watches/watches.module').then(m => m.WatchesModule),
            canMatch    : [ WatchesGuard ],
          },
          ...(environment.features.waste ? [ {
            path        : 'waste',
            loadChildren: () => import('../modules/waste/waste.module').then(m => m.WasteModule),
            canMatch    : [ WasteGuard ],
          } ] : []),
          { path: '**', redirectTo: 'dashboard', },
        ]
      }
    ]
  },
]

@NgModule({
  imports  : [ RouterModule.forRoot(routes) ],
  exports  : [ RouterModule ],
  providers: []
})
export class CoreRoutingModule { }
